import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

class NotFoundPage extends Component {
  render() {
    return (
      <Fragment>
	      <Helmet>
          <title>404 Not Found</title>
        </Helmet>
        <div className="not-found-page">
          <h1 className="not-found-page__heading not-found-page__heading--blue">
            404
          </h1>
          <h2 className="not-found-page__heading">
            Page Not Found
          </h2>
          <div className="not-found-page__subheading">
            The page you are looking for doesn’t exist or an error occured.
          </div>
          <div className="not-found-page__button-wrapper">
            <Link to="/" className="button">
              Back to Home
            </Link>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/pages/NotFoundPage.js